import { Component, Input } from "@angular/core";

@Component({
	selector: "performance-indicators-notification",
	templateUrl: "./performance-indicators-notification.component.html",
	styleUrls: ["./performance-indicators-notification.component.scss"],
	standalone: false
})
export class PerformanceIndicatorsNotificationComponent {
	@Input() public timeframeValue?: string = "24h";
	@Input() public classes: string | string[];
}
